__turbopack_context__.v({
  "container": "[---slug]-module__BKJEya__container",
  "containerWithMenu": "[---slug]-module__BKJEya__containerWithMenu",
  "fadeInItems": "[---slug]-module__BKJEya__fadeInItems",
  "menu": "[---slug]-module__BKJEya__menu",
  "menuLink": "[---slug]-module__BKJEya__menuLink",
  "spacing--lg": "[---slug]-module__BKJEya__spacing--lg",
  "spacing--md": "[---slug]-module__BKJEya__spacing--md",
  "spacing--sm": "[---slug]-module__BKJEya__spacing--sm",
  "spacing--xl": "[---slug]-module__BKJEya__spacing--xl",
  "spacing--xs": "[---slug]-module__BKJEya__spacing--xs",
  "spacing--xxl": "[---slug]-module__BKJEya__spacing--xxl",
  "spacing--xxs": "[---slug]-module__BKJEya__spacing--xxs",
  "spacing--xxxl": "[---slug]-module__BKJEya__spacing--xxxl",
  "spacing--xxxs": "[---slug]-module__BKJEya__spacing--xxxs",
});
